
import { toast } from "react-toastify";

const showConfirmToast = ({ message, onConfirm, onCancel, id }) => {
  const toastId = toast(
    ({ closeToast }) => (
      <div>
        <p>{message}</p>
        <div className="d-flex justify-content-end gap-2 mt-2">
          <button
            className="btn btn-sm btn-danger"
            onClick={() => {
              onConfirm?.();
              toast.dismiss(toastId);
            }}
          >
            Yes
          </button>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => {
              onCancel?.();
              toast.dismiss(toastId);
            }}
          >
            No
          </button>
        </div>
      </div>
    ),
    {
      autoClose: false,
      closeOnClick: false,
      closeButton: false,
      position: "top-center",
      toastId: id || `confirm-${Date.now()}`,
    }
  );
};

export default showConfirmToast;
